import Vue from 'vue';

Vue.component('KaurnaRegister', require('./KaurnaRegister.vue'));




// WEBPACK FOOTER //
// ./resources/assets/js/components/community/atsi/welcome-to-country.js